<template>
  <div class="form-member-choose">
    <div v-if="showUsers" class="member-btn">
      <div v-if="!isText" class="open" @click="initEdit">
        <slot>
          <el-button size="small" type="primary">{{ title }}</el-button>
        </slot>
      </div>
      <div class="member-list" :class="{'has-user': showList.length > 0 && !isText}">
        <el-tag
          v-for="(item, index) in showList"
          :key="index + 'member'"
          :closable="!isText"
          type="info"
          style="margin-right: 8px; margin-bottom: 8px"
          @close="deletItem(item)"
        >
          <img :src="item.avatar || circleUrl" alt="">
          <span>
            {{ item.name || item.departmentName }}
          </span>
        </el-tag>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" custom-class="hasborder-dialog" width="640px" @close="handleClose">
      <div class="member member-flex member-jsb">
        <div class="member-left">
          <el-input v-model="searchInfo" class="searchInput" :clearable="true" size="small" placeholder="搜索员工（回车搜索）" suffix-icon="el-icon-search" @change="debounceSearch" />
          <div class="scrollbar-wrapper">
            <el-tree
              v-if="isShowTree"
              node-key="id"
              :data="dataList"
              :props="defaultProps"
              :expand-on-click-node="false"
              :check-on-click-node="true"
              :default-expand-all="false"
              :default-expanded-keys="defaultExpandedKeys"
              class="member-left-tree"
              @node-click="handleNodeClick"
            >
              <span slot-scope="{ data }" class="custom-tree-node">
                <!-- <span>{{ data.value }} ({{ data.num }})</span> -->
                <span>{{ data.value }} ({{ data.userCount }})</span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="member-right" @scroll.passive="handleTooltipScroll">
          <div class="member-right-header member-flex member-jsb">
            <p class="member-right-text">已选员工（ {{ activeIDList.length }}/{{ mapList.length }} ）</p>
            <div v-show="mapList.length > 0" class="member-flex member-ac">
              <p class="member-right-all">全选</p>
              <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" size="small" @change="handleCheckAllChange" />
            </div>
          </div>
          <el-checkbox-group v-model="activeIDList" class="checkbox-out-center" @change="handleCheckedCitiesChange">
            <div v-for="(item,index) in mapList" :key="index" class="member-flex member-jsb checkbox-out member-ac">
              <div class="member-flex member-ac">
                <!-- <el-avatar :src="item.avatar?item.avatar:circleUrl" :size="40" /> -->
                <el-image :src="item.avatar ? item.avatar : circleUrl" :size="40" fit="cover" lazy />
                <p class="checkbox-out-man">
                  <el-tooltip class="item" effect="dark" :disabled="disabledTooltip" :visible-arrow="false" :content="joinDepartmnets(item.departments, item.name)" placement="top-start">
                    <span> {{ joinDepartmnets(item.departments, item.name) }}</span>
                  </el-tooltip>
                </p>
              </div>
              <el-checkbox :disabled="disabledUsers.includes(item.userId)" :label="item.id" @click.native="checkLimit" @change="changeCheckbox($event,item,index)"><br></el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" class="line-btn" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// src\views\approvalCenter\api\index.js
import { getDepartmentTree, getDepartmentUsers } from '@/views/approvalCenter/api'
import { getUserNameList } from '@/views/processManage/api'
import { deepClone } from '@/utils'
import cloneDeep from 'lodash/cloneDeep'
// 搜索点击限制频数
import { debounce } from '@/utils/index'
import { mapState } from 'vuex'
// import { getVisibleDepartEnterpriseList, getVisibleUserEnterpriseList } from '@/api'
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    // 分支中文描述
    info: {
      type: String,
      default: ''
    },
    isText: {
      type: Boolean, // 只展示内容
      default: false
    },
    showUsers: {
      type: Boolean, // 展示tag标签
      default: false
    },
    title: {
      type: String,
      default: '选择成员'
    },
    // 限制选择人数
    limit: {
      type: Number,
      default: 0
    },
    // 禁止选中的用户
    disabledUsers: {
      type: Array,
      default: () => []
    },
    hasSubmit: {
      type: Boolean, // 是否触发提交
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      allList: [], // 所有人员信息，用于回显
      mapList: [], // 人员数组
      activeIDList: [], // 当前选中的人员id数组
      activeList: [], // 当前选中的人员数组
      chooseList: [], // 上次选中的人员数组
      dataList: [],
      defaultExpandedKeys: [],
      allListMap: {}, // 所有人id数据
      defaultProps: {
        children: 'childList',
        value: 'value'
      }, // 修改树形结构默认对应的字段名字
      checkAll: false, // 是否全选人员
      userDataMap2: {},
      isShowTree: true, //
      isIndeterminate: true, //
      departmentId: null, // 部门id
      searchInfo: null, // 输入框值
      activeObject: {}, // 当前选中的部门对象
      disabledTooltip: false // 滚动中tooltip无效
    }
  },
  computed: {
    ...mapState('async', ['usersMap']),
    showList() {
      const showList = []
      const obj = {}
      this.value.forEach((id) => {
        const rolrItem = this.allListMap[id] || this.usersMap[id] || this.userDataMap2[id]
        if (!obj[id] && rolrItem) {
          obj[id] = id
          showList.push(rolrItem)
        }
      })
      return showList
    }
  },
  mounted() {
    this.getLastUserList()
    this.getAllUserInfo()
    if (this.value && this.value.length > 0) {
      this.initDefault()
    }
  },
  methods: {
    getLastUserList() {
      if (this.value.length <= 0) {
        return
      }
      getUserNameList({ userIds: this.value }).then((res) => {
        const list = res.data
        const userDataMap2 = {}
        list.forEach((item) => {
          item.accountName = item.name
          item.id = item.userId
          userDataMap2[item.id] = item
        })
        this.userDataMap2 = userDataMap2
      })
    },
    async getAllUserInfo() {
      try {
        const res = await getDepartmentUsers({})
        if (res.code === 200 && res.data) {
          res.data.forEach(item => {
            item.accountName = item.name
            item.id = item.userId
          })
          this.allList = res.data
          const allListMap = {}
          this.allList.map((item) => {
            if (item.id) {
              allListMap[item.id] = item
            }
          })
          this.allListMap = Object.freeze(allListMap)
        }
      } catch (err) {
        console.log(err)
      }
    },
    initDefault() {
      this.activeIDList = cloneDeep(this.value)
    },
    // 检查是否超出限制
    checkLimit(e) {
      e.stopPropagation()
    },
    // 删除人员
    deletItem(data) {
      this.activeIDList = this.activeIDList.filter((item) => item !== data.id)
      this.$emit('input', cloneDeep(this.activeIDList))
      this.$emit('validateProp')
      this.sendInfo()
    },
    // 滚动时不显示tooltip
    handleTooltipScroll() {
      this.disabledTooltip = true
      if (this.toolTipTimer) {
        clearTimeout(this.toolTipTimer)
      }
      this.toolTipTimer = setTimeout(() => {
        this.disabledTooltip = false
      }, 200)
    },
    //   获取可见部门数据列表
    async getDataList() {
      const res = await getDepartmentTree(JSON.stringify({}))
      // eslint-disable-next-line eqeqeq
      if (res.code == 200) {
        this.dataList = res.data
        // 初次进入获得是全部人员,用户遍历id回显
        if (res.data && res.data.length > 0 && res.data[0]['visible']) {
          // this.defaultExpandedKeys = [res.data[0].id]
          this.handleNodeClick(res.data[0])
        }
      }
    },
    // 搜索节流
    debounceSearch: debounce(function() {
      this.getDataMapList(0)
    }, 1000),
    // 人员信息列表
    async getDataMapList(type, isFirst) {
      const { departmentId, searchInfo } = this
      let params = {
        departmentIds: null,
        name: searchInfo || null
      }
      if (type || !searchInfo) {
        params = {
          departmentIds: [departmentId],
          name: null
        }
      }
      const res = await getDepartmentUsers(JSON.stringify(params))
      // eslint-disable-next-line eqeqeq
      if (res.code == 200) {
        res.data.forEach(item => {
          item.accountName = item.name
          item.id = item.userId
        })
        this.mapList = res.data
        if (type || !searchInfo) {
          this.isShowTree = true
        } else {
          this.isShowTree = false
        }
        this.checkAllValue()
      }
    },
    checkAllValue() {
      const arr = this.mapList.filter(item => {
        return this.activeIDList.indexOf(item.id) !== -1
      })
      if (arr.length === this.mapList.length) {
        this.checkAll = true
      } else if (arr.length > 0) {
        this.isIndeterminate = true
        this.checkAll = false
      } else {
        this.isIndeterminate = false
        this.checkAll = false
      }
    },
    // 打开弹框 初始化数据
    openD() {
      this.activeIDList = []
      this.activeList = []
      this.searchInfo = ''
      this.mapList = []
      this.dialogVisible = true
      this.checkAll = false
      this.isIndeterminate = true
      this.getAllUserInfo()
      this.getDataList()
    },
    // 编辑回显
    initEdit() {
      console.log('this.value', this.value)
      const list = deepClone(this.value)
      this.defaultExpandedKeys = this.value
      this.activeIDList = deepClone(list)
      this.activeList = deepClone(list)
      this.searchInfo = ''
      this.mapList = []
      this.dialogVisible = true
      this.checkAll = false
      this.isIndeterminate = true
      this.getDataList()
    },
    // checkList显示
    initCheckList() {

    },
    submit() {
      if (this.limit && this.activeList.length > this.limit) {
        return this.$message.error(`仅支持选择${this.limit}人`)
      } else {
        this.dialogVisible = false
      }
      this.$emit('input', cloneDeep(this.activeIDList))
      if (this.hasSubmit) {
        this.$emit('submit', this.activeList)
      }
      this.$emit('validateProp')
      this.sendInfo()
    },
    // 生成分支回显数据
    sendInfo() {
      const infoList = []
      this.activeIDList.map((item) => {
        // return this.allListMap[item].name
        if (this.allListMap[item] && this.allListMap[item].name) {
          infoList.push(this.allListMap[item].name)
        }
      })
      if (infoList.length > 0) {
        this.$emit('update:info', infoList.join('、'))
      } else {
        this.$emit('update:info', '')
      }
    },
    //   关闭弹框
    handleClose() {
      this.dialogVisible = false
      this.activeIDList = cloneDeep(this.value)
      this.$emit('close')
    },
    //   点击左侧的树形结构
    handleNodeClick(data, isFirst) {
      if (!data.visible) {
        this.$message('当前部门不可选')
        return
      }
      this.activeObject = data
      this.checkAll = false
      this.isIndeterminate = false
      this.departmentId = data.id
      this.getDataMapList(1, isFirst)
    },
    // 全选
    handleCheckAllChange(val) {
      if (!val) {
        const arrlist = this.mapList.map(v => v.id)
        this.activeList = this.activeList.filter(item => !arrlist.includes(item.id))
      } else {
        this.mapList.forEach(item => {
          const isCludes = this.activeIDList.includes(item.id)
          if (!isCludes && !this.disabledUsers.includes(item.id)) {
            this.activeList.push(item)
          }
        })
      }
      this.activeIDList = this.activeList.map(v => v.id)
      this.isIndeterminate = false
    },
    // 选中单个
    handleCheckedCitiesChange(value) {
      this.checkAllValue()
    },
    changeCheckbox(e, tItem, Index) {
      if (this.limit === 1 && this.activeList.length === 1) {
        this.activeList = []
        this.activeIDList = [tItem.id]
        // return this.$message.error('最大不能超过1')
      }
      const index = this.activeList.findIndex((item) => item.id === tItem.id)
      if (index !== -1) {
        this.activeList.splice(index, 1)
      } else {
        this.activeList.push(tItem)
      }
    },
    //   去重
    unique(arr) {
      return Array.from(new Set(arr))
    },
    // 显示部门
    joinDepartmnets(departments, name) {
      if (departments && departments.length > 0) {
        const departName = departments.map((item) => item.name).join('、')
        return name + `（${departName}）`
      }
      return name
    }
  }
}
</script>

<style lang="scss" scoped>
.searchInput{
  /deep/.el-input__validateIcon {
      display:none!important;
    }
  }

/deep/ .el-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
/deep/.el-dialog__body {
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  padding: 0;
}
/deep/.el-tree-node__content {
  height: 40px;
}
.form-member-choose {
  .member-btn {
    .open {
      display: inline-block;
    }
    .member-list {
      &.has-user {
        padding-top: 16px;
      }
      // padding: 10px 0px;
      display: flex;
      flex-wrap: wrap;
      max-height: 200px;
      overflow-y: auto;
      /deep/img {
        width: 24px;
        height: 24px;
        object-fit: fill;
      }
      /deep/.el-tag__close {
      color: #333;
      }
      /deep/.el-tag {
        color: #333;
        cursor: pointer;
        display: flex;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
          border-radius: 24px;
          vertical-align: middle;
          margin-right: 8px;
        }
        span {
          // line-height: 40px;
          display: inline-block;
          vertical-align: top;
        }
        .el-tag__close {
          transform: translateY(2px);
        }
        &:hover {
          color: $wit-primary;
          background-color: $wit-opacity9;
          .el-tag__close {
            color: $wit-primary;
            background-color: $wit-opacity6;
          }
        }
      }
    }
  }
}
.member-flex {
  display: flex;
}
.member-jsb {
  justify-content: space-between;
}
.member-ac {
  align-items: center;
  /deep/.el-checkbox__label {
    padding-left: 0;
  }
  /deep/.el-avatar {
    min-width: 40px;
  }
}
.member {
  .member-left {
    width: 50%;
    padding: 16px;
    padding-left: 32px;
    height: 500px;
    overflow: auto;
    .scrollbar-wrapper {
      height: calc(100% - 70px);
    }
    .member-left-tree {
      // width: 100%;
      margin-top: 20px;
      //  overflow-x: scroll;
    }
    /deep/.el-tree-node.is-expanded > .el-tree-node__children {
      overflow: visible;
    }
  }
  .member-right {
    width: 50%;
    border-left: 1px solid #d8d8d8;
    padding: 28px 32px 16px 16px;
    font-size: 14px;
    color: #333333;
    height: 500px;
    overflow-y: scroll;
    .checkbox-out-center {
      margin-top: 32px;
      .checkbox-out {
        margin-top: 12px;
        .checkbox-out-man {
          padding-left: 15px;
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          width: 209px;
          white-space: nowrap;/*内容超宽后禁止换行显示*/
          overflow: hidden;/*超出部分隐藏*/
          text-overflow:ellipsis;/*文字超出部分以省略号显示*/
        }
      }
    }
    .member-right-all {
      margin-right: 12px;
    }
  }
}
.el-button + .el-button {
  margin-left: 10px;
}
body.sys-deep-style {
  .member-right {
    color: #c0c4cc;
    border-left: 1px solid #848484;
    .checkbox-out-center {
      .checkbox-out {
        .checkbox-out-man {
          color: #c0c4cc;
        }
      }
    }
  }
  /deep/ .el-dialog__body {
    border-top: 1px solid #848484 !important;
    border-bottom: 1px solid #848484 !important;
  }
}
</style>
